import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category", label: "女主播分类", end: false },
  { to: "/videos", label: "视频专辑", end: false },
  { to: "/gallery", label: "写真图库", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function SiteNavbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/category?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="flex items-center gap-4 px-4 md:px-8 h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-lg bg-primary-600 flex items-center justify-center text-background-50">
            <i className="ri-live-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-lg text-foreground-950">韩国女主播</span>
            <span className="text-[10px] tracking-[0.2em] text-accent-600 uppercase">Star Channel</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? "text-accent-600 bg-accent-50"
                    : "text-foreground-700 hover:text-accent-600 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden md:flex items-center ml-auto">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索主播名称或关键词"
              className="w-56 lg:w-64 h-10 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 focus:bg-background-50 transition-colors"
            />
          </div>
          <button
            type="submit"
            className="ml-2 h-10 px-4 rounded-full bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-700 transition-colors cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto md:ml-0 lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4 space-y-3 animate-fade-in">
          <form onSubmit={handleSearch} className="flex items-center gap-2 md:hidden">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索主播名称或关键词"
                className="w-full h-11 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm focus:outline-none focus:border-accent-400"
              />
            </div>
            <button
              type="submit"
              className="h-11 px-4 rounded-full bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base font-medium border-b border-background-100 last:border-0 ${
                    isActive ? "text-accent-600" : "text-foreground-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}